import React from 'react'

import Policies from '../components/Policies/Policies'

const TermAndCondition = () => {
    return (
        <>
             <Policies policyTitle={"Terms And Conditions"}/>
             <section className="main-content-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="privacy-content">
                <p>
                  <strong>Our Privacy Policy Objective</strong><br />Paper Help Desk is committed to protecting your privacy when
                  you visit our Site(s). We want you to know what Information we collect, how we use it, and
                  how you can request that this Information be updated or corrected.
                </p>
                <p>The organisation reserves the right to amend or otherwise modify
                  this Privacy Policy at any time, so please re-visit this page periodically to check for
                  updates. The date of last revision is shown at the top of this document. </p>
                <p><strong>Scope</strong><br />Our Privacy Policy covers any visitor to our Site(s). This
                  policy applies to both online and offline collection, storage, processing, and transfer of
                  Personal Information.</p>
                <ul>
                  <li>Definitions</li>
                  <li>Information We Collect</li>
                  <li>Information Collected Automatically</li>
                  <li>Information You Provide to Us</li>
                  <li>How We Use This Information</li>
                  <li>Opt Out</li>
                  <li>Our Security Measures</li>
                  <li>Call Monitoring</li>
                  <li>Internet Technologies Used</li>
                  <li>Children's Privacy</li>
                  <li>Site Hosting and Links From Our Sites to Other Websites</li>
                  <li>Privacy Policy Changes</li>
                  <li>How to Access Your Information and Contact Us</li>
                </ul>
                <p><strong>Definitions</strong><br />As used in this Privacy Policy, the following terms have the
                  following meanings:</p>
                <p>Business Associates" means third party service providers which the
                  Organisation may contract with to provide services on their behalf including those related
                  to the Site(s) or for transactions occurring on the Site(s) including, but not limited to
                  Social Networking, hosting, web analytics, lead generation, academic, business or financial
                  services.</p>
                <p><strong>Information We
                    Collect</strong><br />We collect various types of Information
                  from you through our Sites, when we talk to you on the phone. Some of this Information is
                  collected automatically through various web and internet technologies including Social
                  Networking tools used by the Organisation. Other Information is collected when you provide
                  it in response to an advertisement, or a request for information; or if you register or
                  order educational or other products and services, set up a Social Network or other Site
                  profile, or if you choose to use one of our learning assessments or other interactive tools.
                </p>
                <p>Our collection of Web Analytical Information lets us see how users
                  are finding, and navigating our Sites, user preferences regarding Site or Social Networking
                  Content, and it tells us which pages users visited most often so we can make our Sites more
                  useful and relevant. This Information may be linked with personal Information to accomplish
                  the purposes described in this Privacy Policy.</p>
                <p><strong>Information Collected
                    Automatically</strong><br />Each time you visit one of our
                  Sites, Web Analytical Information is automatically gathered. In general, this Information
                  does not identify you personally. Examples of Web Analytical Information include, but are
                  not limited to:</p>
                <ul>
                  <li>IP address</li>
                  <li>Collection Date</li>
                  <li>Publisher Name</li>
                  <li>Connection Speed</li>
                  <li>Day of Week Time of Day (hour)</li>
                  <li>Language settings</li>
                  <li>Country, State, DMA, City (relating to IP address, if
                    available)</li>
                  <li>Domain (.com, .net, .mil, .org, .edu, etc.)</li>
                </ul>
                <p><strong>Information You Provide to
                    Us</strong><br />In addition to the Web Analytical Information
                  automatically collected when you visit our Sites, the Organisation also collects, uses and
                  discloses Personal Information that you provide to us voluntarily when you respond to an
                  advertisement or a request for information; or if you register or order educational or other
                  products and services, set up a Social Network or other Site profile, or if you choose to
                  use one of our learning assessments or other interactive tools.. While the exact nature of
                  the Personal Information may vary depending on the type of response or service requested,
                  the following is a non-exclusive list of the types of Information that may be collected to
                  the extent it is necessary and applicable for the intended purposes:</p>
                <ul>
                  <li>First, Middle and Last Name</li>
                  <li>Street Address, City, State, Country, Postal Code</li>
                  <li>Gender</li>
                  <li>Country of origin </li>
                  <li>Address Type </li>
                  <li>E-mail address</li>
                  <li>Valid Day or Evening Telephone Number</li>
                  <li>Cell Phone Number </li>
                  <li>Confirmation of the age of majority</li>
                  <li>Publisher Code (SiteID)</li>
                  <li>Lead Source </li>
                  <li>Credit Card Number </li>
                  <li>Social Networking Content</li>
                </ul>
                <p><strong>How We Use This
                    Information</strong><br />Marketing Information We use
                  marketing Information to help us better plan our Sites and services to meet your needs; to
                  measure and improve our Site(s)' services and features, to communicate with you by e-mail,
                  postal mail, telephone, cellular/mobile phone, PDA devices, and/or on applications for
                  mobile phones such as iPhone or Blackberry about products or services that may be of
                  interest to you, to provide you with customer support, to prevent potentially illegal
                  activities (including illegal downloading of copyrighted materials in accordance with our
                  Copyright Infringement policy), and to enforce our Terms of Use. We also use a variety of
                  technological systems to detect and address anomalous activity and to screen content to
                  prevent certain abuses such as spam. These efforts may on occasion result in permanent
                  suspension or termination of Site functionality for some users.</p>
                <p><strong>Personal
                    Information</strong><br />The Organisation recognises that by
                  choosing to provide us with your Personal Information, you are demonstrating your trust in
                  us and we take that trust seriously. We will not sell, rent or lease your Personal
                  Information to others. We may collect, use and disclose Personal Information for the
                  following purposes:</p>
                <ul>
                  <li>to provide requested products and services</li>
                  <li>to respond to your inquiries</li>
                  <li>to administer promotions to which you have indicated an
                    interest </li>
                  <li>for our internal marketing purposes, which includes, but is
                    not limited to, sending you material about products, services, updates, etc. that we
                    think may be of interest to you </li>
                  <li>for fostering communication and collaboration among members
                    of the Organisation community through Social Networks </li>
                  <li>for sharing with our Partners who may contact you with
                    respect to their services; </li>
                  <li>for sharing with our Partners or Business Associates who are
                    performing services on our behalf </li>
                  <li>to analyse how Sites and services are being accessed and
                    used;</li>
                  <li>to improve Site and service performance and delivery</li>
                  <li>to analyse academic and learning outcomes and preferences
                  </li>
                  <li>to analyse risk and business results</li>
                  <li>to obtain payment for services that we provide to you </li>
                  <li>to maintain business records for reasonable periods</li>
                </ul>
                <p><strong>Financial
                    Information</strong><br />Your Financial Information will be
                  used to provide requested products and services, to analyse operational and business
                  results, to analyse risk, and for concluding your registration or other transaction you have
                  initiated with us. It will not be sold, rented, or otherwise transferred to an Educational
                  Partner, Business Associate or Unrelated Entity outside of this purpose, except in the case
                  of a reorganisation, merger or acquisition of our shares or assets.</p>
                <p>We use Secure Socket Layer (SSL) 128 bit encryption to protect
                  your credit card details submitted to us over the Internet. No one can view your credit card
                  information, not even our staff members</p>
                <p><strong>Opt-Out</strong><br />You may opt-out of our collection, use and disclosure of your
                  Personal Information at any time, subject to contractual, academic, legal or technical
                  restrictions and reasonable notice. Note that if you opt-out of certain uses of your
                  Personal Information, we may no longer be able to provide certain products or services. You
                  may not be permitted to opt-out to certain necessary collection, uses and disclosures, for
                  example, but not limited to, educational announcements, maintaining reasonable academic,
                  business and transaction records and disclosures to government entities as required for us
                  to comply with applicable laws. Click here to opt-out.</p>
                <p><strong>Our Security
                    Measures</strong><br />We will take commercially reasonable
                  measures to secure and store your Information to protect against the loss, misuse, and
                  alteration of the Information under our control. We utilise industry standard security
                  measures when accepting your credit card Information during the online ordering process, as
                  well as whenever we ask you to login to any of our Site(s).</p>
                <p>Unfortunately, no data transmission over the internet can be
                  guaranteed to be completely secure. As a result, although we will utilise such measures, we
                  do not guarantee you against the loss, misuse, or alteration of Information under our
                  control, and you provide Information to us at your own risk. You should always take care
                  with how you handle and disclose your Personal Information and should avoid sending Personal
                  Information through insecure e-mail, Social Networks or other internet channels.</p>
                <p><strong>Monitoring of
                    Communications</strong><br />We may monitor and retain all
                  incoming and outgoing communications for training of our representatives and for quality
                  assurance purposes. To the extent such communications are selected, they are only retained
                  as long as necessary to adequately discharge these purposes, unless a specific communication
                  needs to be retained for legal reasons. If you prefer that your communications not be
                  retained for any reason, please advise your representative.</p>
                <p><strong>Internet Technologies
                    Used</strong><br />Cookies, web beacons and other relevant
                  internet technologies are used on our Sites to allow us to accomplish the uses set out above
                  as well as to deliver Sites messaging and to keep track of your Information. These small
                  pieces of program code reside in your computer and browser and can be removed. If you desire
                  to remove such technologies you may do so, but this may render our Sites unusable to you.
                  You can opt out of cookies or the other internet technologies used by disabling these
                  features in your browser program. Consult your browser's "Help" menu for assistance in
                  changing cookie settings or removing cookie files.</p>
                <p><strong>Children's Privacy</strong><br />We are very sensitive to the issue of children's privacy. Our
                  Sites are neither developed for, nor directed at children under 13. If you believe your
                  child has provided us with Personal Information, or registered at one of our Sites and would
                  like to have this Information removed, click here.</p>
                <p><strong>Privacy Policy
                    Changes</strong><br />Paper Help Desk may update this Privacy
                  Policy or revise it from time to time. If you are concerned about how your Personal
                  Information is used or disclosed you should contact us as described below or check back at
                  this Site periodically to obtain a current copy of this Privacy Policy. We urge you to
                  review this Privacy Policy frequently to obtain the current version. Your continued
                  provision of Personal Information or use of our services following any changes to this
                  Privacy Policy constitutes your acceptance of such changes. If we intend to use Information
                  that personally identifies you in a manner materially different from what we stated at the
                  time it was collected, we will attempt to notify you at least 30 days in advance. You will
                  be given a choice as to whether or not previously provided Information may be used in a new
                  way.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
        </>
    )
}

export default TermAndCondition
